import React, { useEffect, useRef, useState } from "react";
import { ReactNode } from "react";

import { motion } from "framer-motion";
import { twJoin, twMerge } from "tailwind-merge";

import {
  useDebounceCallback,
  useMediaQuery,
  useResizeObserver,
} from "usehooks-ts";

interface FlippableCardProps {
  front: ReactNode;
  back: ReactNode;
  flipped: boolean; // always controlled
  onFlipChange?: (flipped: boolean) => void;
  flipOnClick?: boolean; // default true
  className?: string;
  height?: string; // default 500px
}

export function FlippableCard({
  front,
  back,
  flipped,
  onFlipChange,
  height = "500px",
  flipOnClick,
  className,
}: FlippableCardProps) {
  const handleFlip = () => {
    if (onFlipChange) onFlipChange(!flipped);
  };
  return (
    <div
      className={twJoin(className)}
      style={{
        perspective: "1000px",
        height,
      }}
    >
      <motion.div
        className="relative h-full w-full cursor-pointer"
        style={{ transformStyle: "preserve-3d" }}
        animate={{ rotateY: flipped ? 180 : 0 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        onClick={flipOnClick ? handleFlip : undefined}
      >
        {/* Front */}
        <div
          className="absolute inset-0 h-full"
          style={{ backfaceVisibility: "hidden" }}
        >
          {front}
        </div>

        {/* Back */}
        <div
          className="absolute inset-0 h-full"
          style={{
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
          }}
        >
          {back}
        </div>
      </motion.div>
    </div>
  );
}

export default FlippableCard;
